import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import KendoScheduler from '../../kendoUI/Scheduler/KendoScheduler';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const show = props.showCalenderModal;
  const handleClose = props.handleClose;
  const handleSave = props.handleSave;
  const multiShiftData = props.multiShiftData;
  const startDate = props.startDate;

  // console.log(multiShiftData);

  return (
    <>
      <div id="openCalenderModal">
        {/* <Modal size="xl" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Scheduler Calender</Modal.Title>
          </Modal.Header>

          <Modal.Body>
           <KendoScheduler
              multiShiftData={multiShiftData}
              handleSave={handleSave}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal> */}

        <div style={{ display: `${show}? block : none` }}>
          <KendoScheduler
            multiShiftData={multiShiftData}
            handleSave={handleSave}
            startDate={startDate}
          />
        </div>
      </div>
    </>
  );
};
